import StorageService from '@/utils/storage-service';

const storage = StorageService.getStorage();

const res = storage.getItem('IS_INTERFACE_PREVIEW_ENABLED');
const isInterfacePreviewEnabled = [undefined, null].includes(res) ? true : res;

// initialed state
export const initialState = () => ({
	selectedWorkflowId: null,
	contextualLoading: false,
	isPublishLoading: false,
	isInterfacePreviewEnabled,
});

const state = initialState();

export default state;
